<template lang="html">
  <div class="course-sudents-component">
    <v-container>
      <v-container>

      <v-text-field
        v-model="search_students_name"
        @keyup.enter="fetchStudentsToAdd(), course_students = null"
        ref="search_students_to_add_input"
        label="Tanuló hozzáadása"
        outlined
        clearable
        prepend-inner-icon="search"
      ></v-text-field>

      <v-btn v-if="students_to_add" @click="CourseStudents()" rounded color="primary">
        Tanulók listája
        <v-icon right dark>undo</v-icon>
      </v-btn>
      </v-container>

      <v-row v-if="!students_to_add" justify="center">
      <v-col cols="12" md="4">
        <v-btn
          color="primary"
          rounded
          @click="message_dialog = true"
        >
        Üzenet küldése
        </v-btn>
      </v-col>
      <v-col cols="12" md="4">
        <v-btn
          color="primary"
          rounded
          @click="createStudIds"
        >
        Azonosító generálás
        </v-btn>
      </v-col>
      <v-col cols="12" md="4">
        <v-btn
          v-if="is_GKI"
          color="primary"
          rounded
          @click="gki_portal_dialog = true"
        >
        GKI teszt regisztráció
        </v-btn>
      </v-col>
      </v-row>

      <v-card>
        <v-card-title>
          Tanulók listája
          <v-spacer></v-spacer>
        </v-card-title>
        <v-data-table
        v-model="isSelected"
        v-if="course_students"
        :headers="course_students_headers"
        :items="course_students"
        :items-per-page="40"
        :mobile-breakpoint='NaN'
        item-key="customer_id"
        hide-default-footer
        single-select
        >
          <template v-slot:item="{item, index, isSelected, select}">
              <tr :style="item.status == 'Preregistred' ? {'background': '#FFF3E0'} : ''">
                <td><v-checkbox color="primary" :value="isSelected" @change="select($event)"></v-checkbox></td>
                <td>{{index+1}}</td>
                <td style='min-width: 150px'><a @click="goToStudent(item.contract_id, item.customer_id)">{{ item.full_name }}</a></td>
                <td style='min-width: 110px'>{{ item.date }}</td>
                <td style='min-width: 120px'>
                  <v-edit-dialog
                    :return-value.sync="item.course_student_id"
                    large
                    persistent
                    save-text="Mentés"
                    cancel-text="Mégsem"
                    @open="getStudIds(item.contract_id, item.customer_id)"
                    @save="updateStudId(item.course_data_id, item.course_student_id)"
                  >
                    <div>{{ item.course_student_id }}</div>
                    <template v-slot:input>
                      <v-select
                        v-model="item.course_student_id"
                        :items="stud_ids"
                        item-text="course_student_id"
                        label="Tanuló azonosító"
                      ></v-select>
                    </template>
                  </v-edit-dialog>
                </td>
                <td style='min-width: 120px'>{{ item.course_type }}</td>
              </tr>
          </template>
        </v-data-table>
        <v-container>
        <v-row v-if="course_students">
        <v-col cols="12" md="3">
        <v-btn
          v-if="isSelected != ''"
          :disabled="selected_status == 'Preregistred'"
          color="primary"
          class="mr-2"
          rounded
          @click="preg_status = 'Preregistred', pregStudents()"
        >
        Előregisztrál
        </v-btn>
        </v-col>
        <v-col cols="12" md="3">
        <v-btn
          v-if="isSelected != ''"
          :disabled="selected_status == 'Pending'"
          color="primary"
          class="mr-2"
          rounded
          @click="finalize_confirm = true, PaymentsForFinalize()"
        >
        Véglegesít
        </v-btn>
        </v-col>
        <v-col md="2">
        <v-btn
          v-if="isSelected != ''"
          color="primary"
          class="mr-2"
          rounded
          @click="del_student_dialog = true"
        >
        Töröl
        </v-btn>
        </v-col>
        </v-row>
        </v-container>
        <v-data-table
        v-model="selected_students"
        v-if="students_to_add"
        :headers="add_student_header"
        :items="students_to_add"
        item-key="contract_id"
        show-select
        :mobile-breakpoint='NaN'
        single-select
        >
        <template v-slot:footer="{pagination}">
          <v-container>
            <v-btn
              v-if="selected_students != ''"
              rounded
              color="primary"
              @click="add_to_course_confirm = true, Payments()"
              :disabled="check_loader"
            >
            Tanfolyamhoz rendelés
            <v-icon dark>mdi-plus</v-icon>
            </v-btn>
          </v-container>
        </template>
        </v-data-table>
      </v-card>
    </v-container>

    <v-snackbar v-model="response_snackbar" bottom>
      <div v-html="response_text"></div>
      <v-btn color="pink" text @click="response_snackbar = false">
        Bezár
      </v-btn>
    </v-snackbar>

    <v-dialog v-model="del_student_dialog" persistent max-width="400">
      <v-card>
        <v-card-text class="pt-4">
          Biztosan eltávolítja a tanulót (<b>{{del_student_name}}</b>) a tanfolyamról?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="delStudents(), del_student_dialog = false">Igen</v-btn>
          <v-btn color="primary" text @click="del_student_dialog = false">Nem</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="add_student_dialog" persistent max-width="400">
      <v-card>
        <v-card-text class="pt-4">
          <p class="red--text"><b>A meghirdetett helyek száma már betelt!</b></p>
          <p>Biztosan hozzáadja a tanuló(ka)t a tanfolyamhoz?</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="addStudentToCourse(), add_student_dialog = false">Igen</v-btn>
          <v-btn color="primary" text @click="add_student_dialog = false">Nem</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="message_dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Üzenet küldése</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark @click="message_dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container>
          <div v-html="message_response"></div>
          <v-row>
          <v-col cols="12" md="6">
            <v-textarea
              v-model="message_text"
              outlined
              name="input-7-4"
              label="Üzenet szövege"
              auto-grow
            ></v-textarea>
          </v-col>
          <v-col cols="6" md="2">
          <v-btn
            :disabled="message_select == '' || message_loader"
            :loading="message_loader"
            color="primary"
            class="mr-2"
            rounded
            @click="messageSend"
          >
          Küld
          </v-btn>
          </v-col>
          </v-row>
        <v-data-table
        v-model="message_select"
        v-if="course_students"
        :headers="message_students_headers"
        :items="course_students"
        :items-per-page="40"
        :mobile-breakpoint='NaN'
        item-key="customer_id"
        hide-default-footer
        show-select
        >
        </v-data-table>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog v-model="gki_portal_dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="purple darken-2">
          <v-toolbar-title>GKI Portál regisztráció</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark @click="gki_portal_dialog = false, gki_students_select = [], gki_reg_response = ''">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container>
        <v-data-table
        v-model="gki_students_select"
        v-if="course_students"
        :headers="message_students_headers"
        :items="course_students"
        :items-per-page="40"
        :mobile-breakpoint='NaN'
        item-key="customer_id"
        hide-default-footer
        show-select
        >
        </v-data-table>
        <v-col cols="12" md="4">
          <v-btn
            color="purple darken-2 white--text"
            rounded
            @click="gkiPortalReg"
          >
          Regisztrál
          </v-btn>
        </v-col>
        <div v-html="gki_reg_response"></div>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog v-model="add_to_course_confirm" persistent max-width="450">
    <v-card>
        <v-container>
        <b>Biztosan hozzáadja a tanulót a tanfolyamhoz?</b>
        <br><br>
        <v-select
          v-model="sel_payment"
          :items="titan_payments"
          label="Befizetés hozzárendelése"
          item-value="payment_id"
          outlined
          rounded
          multiple
        >
        <template v-slot:selection="{ item, index }">
          <v-chip>
            <span>{{ item.amount }} - {{ item.invoice_date }}</span>
          </v-chip>
        </template>

        <template v-slot:item="{ active, item, attrs, on }">
          <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
            <v-list-item-action>
            <v-checkbox :input-value="active"></v-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.amount }} - {{ item.invoice_date }} ({{item.invoice_number}})
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        </v-select>
        <v-checkbox
          v-if="admin"
          v-model="free_learning"
          label="Tandíjmentesség"
        ></v-checkbox>
        <v-checkbox
          v-model="prereg"
          label="Előregisztráció"
        ></v-checkbox>
        </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green" outlined @click="checkCourseStudents(), add_to_course_confirm = false" :disabled="(!sel_payment || sel_payment == '') && !free_learning && !prereg && (course_pattern != 87 && course_pattern != 88 && course_pattern != 89 && course_pattern != 91)">Igen</v-btn>
        <v-btn color="red" outlined @click="add_to_course_confirm = false">Nem</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="finalize_confirm" persistent max-width="450">
    <v-card>
        <v-container>
        <b>Biztosan hozzáadja a tanulót a tanfolyamhoz?</b>
        <br><br>
        <v-select
          v-model="sel_payment"
          :items="titan_payments"
          label="Befizetés hozzárendelése"
          item-value="payment_id"
          outlined
          rounded
          multiple
        >
        <template v-slot:selection="{ item, index }">
          <v-chip>
            <span>{{ item.amount }} - {{ item.invoice_date }}</span>
          </v-chip>
        </template>

        <template v-slot:item="{ active, item, attrs, on }">
          <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
            <v-list-item-action>
            <v-checkbox :input-value="active"></v-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.amount }} - {{ item.invoice_date }} ({{item.invoice_number}})
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        </v-select>
        <v-checkbox
          v-if="admin"
          v-model="free_learning"
          label="Tandíjmentesség"
        ></v-checkbox>
        </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green" outlined @click="preg_status = 'Pending', pregStudents(), finalize_confirm = false" :disabled="(!sel_payment || sel_payment == '') && !free_learning && (course_pattern != 87 && course_pattern != 88 && course_pattern != 89 && course_pattern != 91)">Igen</v-btn>
        <v-btn color="red" outlined @click="finalize_confirm = false">Nem</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  </div>
</template>

<script>
import store from '../store'
import { mapFields } from 'vuex-map-fields'
import router from '../router'
  export default {
    data () {
      return {
        isSelected: '',
        preg_status: '',
        selected_status: '',
        tanfolyamok_tab: null,
        panel: 0,
        course_students: null,
        course_students_headers: [
          { text: ''},
          { text: ''},
          { text: 'Név', value: 'full_name'},
          { text: 'Született', value: 'date' },
          { text: 'Azonosító', value: 'course_student_id' },
          { text: 'Kategória', value: 'course_type' },
        ],
        message_students_headers: [
          { text: 'Név', value: 'full_name'},
          { text: 'Született', value: 'date' },
          { text: 'Azonosító', value: 'course_student_id' },
          { text: 'E-mail cím', value: 'email1' },
          { text: 'Telefon', value: 'phone1' },
        ],
        del_student_dialog: false,
        del_course_data_id: '',
        del_course_id: '',
        del_contract_id: '',
        del_student_name: '',
        del_customer_id: '',
        response_text: '',
        response_snackbar: false,
        search_students_name: '',
        students_to_add: [],
        selected_students: [],
        add_student_header: [
          { text: 'Név', value: 'name'},
          { text: 'Született', value: 'birthdate' },
          { text: 'Szerződés dátuma', value: 'contract_date' },
        ],
        message_dialog: false,
        message_select: [],
        message_text: '',
        message_response: '',
        message_loader: false,
        gki_portal_dialog: false,
        gki_reg_response: '',
        gki_students_select: [],
        add_student_dialog: false,
        check_loader: false,
        add_to_course_confirm: false,
        free_learning: false,
        sel_payment: '',
        titan_payments: [],
        finalize_confirm: false,
        prereg: false,
        stud_ids: []
      }
    },
    methods: {
      CourseStudents: async function() {
        this.isSelected = []
        this.selected_students = []
        this.students_to_add = null
        this.del_customer_id = null
        this.course_students = null
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/tanfolyam_diakok', {
          token: this.token,
          course_id: this.course_id,
        }).then((response) => {
          store.state.showing.preloader = false
          this.course_students = response.data
          if (this.course_students != '') {
            this.students = true
          } else {
            this.students = false
          }
        }, (error) => {
          this.error_text = error.data
        })
      },
      delStudents: async function() {
        this.nevsor_upload = false
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/tanfolyam_del_student_20210805', {
          token: this.token,
          course_data_id: this.isSelected[0]['course_data_id'],
          course_id: this.isSelected[0]['course_id'],
          contract_id: this.isSelected[0]['contract_id'],
          customer_id: this.isSelected[0]['customer_id']
        }).then((response) => {
          store.state.showing.preloader = false
          this.response_snackbar = true
          this.response_text = response.data
          this.lessonHeadcount()
          this.nevsor_upload = true

        }, (error) => {
          this.error_text = error.data
        })
      },
      fetchStudentsToAdd: async function() {
        this.students_to_add = null
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/search_students', {
          token: this.token,
          nev: this.search_students_name,
          course_type_id: this.course_type_id,
          driving_school_id: this.driving_school_id,
        }).then((response) => {
          store.state.showing.preloader = false
          this.students_to_add = response.data

        }, (error) => {
          this.error_text = error.data
        })
      },
      checkCourseStudents: async function() {
        store.state.showing.preloader = true
        this.check_loader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/tanfolyam_diakok_check', {
          token: this.token,
          course_id: this.course_id,
        }).then((response) => {
          this.check_loader = false
          store.state.showing.preloader = false
          if (response.data['result'] == 'error') {
            this.add_student_dialog = true
          } else {
            this.addStudentToCourse()
          }
        }, (error) => {
          this.error_text = error.data
        })
      },
      addStudentToCourse: async function() {
        this.nevsor_upload = false
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/tanfolyam_add_student_20230714', {
          token: this.token,
          course_id: this.course_id,
          customer_details: this.selected_students,
          course_number: this.course_number,
          payment: this.sel_payment,
          free_learning: this.free_learning,
          prereg: this.prereg,
          course_type_key: this.course_type_id
        }).then((response) => {
          store.state.showing.preloader = false
          this.response_text = response.data
          this.add_course_dialog = false
          this.response_snackbar = true
          this.lessonHeadcount()
          this.nevsor_upload = true
        }, (error) => {
          this.error_text = error.data
        })
      },
      lessonHeadcount: async function() {
        this.headcount_update = false
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/lessons_headcount', {
          token: this.token,
          course_id_td: this.course_id,
        }).then((response) => {
          this.headcount_update = response.data
          store.state.showing.preloader = false

          this.CourseStudents()
        }, (error) => {
          this.error_text = error.data
        })
      },
      pregStudents: async function() {
        this.nevsor_upload = false
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/tanfolyam_preg_student_20221103', {
          token: this.token,
          course_data_id: this.isSelected[0]['course_data_id'],
          course_id: this.isSelected[0]['course_id'],
          course_number: this.isSelected[0]['course_number'],
          status: this.preg_status,
          payment: this.sel_payment,
          free_learning: this.free_learning,
          course_type_key: this.course_type_id
        }).then((response) => {
          this.isSelected = ''
          store.state.showing.preloader = false
          this.response_text = response.data['message']
          if (response.data['result'] == 'error') {
            this.snackbar_color = 'error'
            this.snackbar_close = ''
          } else {
            this.snackbar_color = null
            this.snackbar_close = 'pink'
          }
          this.lessonHeadcount()
          this.nevsor_upload = true
          this.response_snackbar = true
        }, (error) => {
          this.error_text = error.data
        })
      },
      goToStudent(contract_id, customer_id) {
        this.Diakok_show = false
        this.DiakokDetails_show = true
        this.contract_id = null
        this.customer_id = null
        this.contract_date = null
        this.contract_id = contract_id
        this.customer_id = customer_id
        router.push({ path: 'diakok' })
      },
      messageSend: async function() {
        if (confirm("Biztosan elküldi az üzenetet?")) {
        this.message_loader = true
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/tanfolyam_message', {
          token: this.token,
          message: this.message_text,
          message_select: this.message_select,
        }).then((response) => {
          this.response_text = response.data
          this.response_snackbar = true
          this.message_dialog = false
          store.state.showing.preloader = false
          this.message_loader = false
          this.message_select = []
        }, (error) => {
          this.error_text = error.data
        })
       }
      },
      messageText() {
        this.$http.get('/tanfolyamok/tanfolyam_message_text'
        ).then((response) => {
          this.message_text = response.data
        }, (error) => {
          this.error_text = error.data
        })
      },
      createStudIds: async function() {
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/generate_stud_ids', {
          token: this.token,
          course_id: this.course_id,
          course_number: this.course_number
        }).then((response) => {
          store.state.showing.preloader = false
          this.CourseStudents()
        }, (error) => {
          this.error_text = error.data
        })
      },
      gkiPortalReg: async function() {
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/pallasz/gki_portal_reg', {
          token: this.token,
          gki_students: this.gki_students_select
        }).then((response) => {
          this.gki_reg_response = response.data
          store.state.showing.preloader = false
        }, (error) => {
          this.error_text = error.data
        })
      },
      Payments: async function() {
        this.sel_payment = null
        this.free_learning = false
        this.prereg = false
        await this.gettoken()
        this.$http.post('/diakok/etitan/payments', {
          token: this.token,
          contract_id: this.selected_students[0]['contract_id']
        }).then((response) => {
          this.titan_payments = response.data;
        }, (error) => {
          console.log(error.data);
        })
      },
      PaymentsForFinalize: async function() {
        this.sel_payment = null
        this.free_learning = false
        await this.gettoken()
        this.$http.post('/diakok/etitan/payments', {
          token: this.token,
          contract_id: this.isSelected[0]['contract_id']
        }).then((response) => {
          this.titan_payments = response.data;
        }, (error) => {
          console.log(error.data);
        })
      },
      getStudIds: async function(contract_id, customer_id) {
        await this.gettoken()
        this.$http.post('/diakok/getStudIds', {
          token: this.token,
          contract_id: contract_id,
          customer_id: customer_id
        }).then((response) => {
          this.stud_ids = response.data;
        }, (error) => {
          console.log(error.data);
        })
      },
      updateStudId: async function(course_data_id, course_student_id) {
        await this.gettoken()
        this.$http.post('/diakok/updateStudIds', {
          token: this.token,
          course_data_id: course_data_id,
          course_student_id: course_student_id
        }).then((response) => {
          console.log(response.data);
          this.CourseStudents()
        }, (error) => {
          console.log(error.data);
        })
      },
    },
    mounted() {
      this.messageText()
    },
    watch: {
      course_id: function (value) {
        if (value != null) {
        this.CourseStudents()
        }
      },
      isSelected: function (value) {
        if (value != '') {
        console.log(value);
        this.selected_status = value[0]['status']
        this.del_student_name = value[0]['full_name']
      }
      },
    },
    computed: {
    ...mapFields([
    'tanfolyamok.course_id',
    'tanfolyamok.course_type_id',
    'tanfolyamok.course_pattern',
    'tanfolyamok.driving_school_id',
    'tanfolyamok.course_number',
    'tanfolyamok.nevsor_upload',
    'tanfolyamok.headcount_update',
    'tanfolyamok.students',
    'tanfolyamok.public_limit',
    'course_details.is_GKI',
    'showing.Diakok_show',
    'showing.DiakokDetails_show',
    'diakok_details.contract_id',
    'diakok_details.customer_id',
    'auth.admin',
  ]),
    noOfStudents: function () {
      if (this.course_students) {
        return this.course_students.length
      }
    }
  },
  }
</script>

<style lang="css">
</style>
